import CleanPcComponent from "../../../../src/events/2023/04/cleanPc/main";
import * as React from 'react';
export default {
  CleanPcComponent,
  React
};